import Vue from 'vue'
import { clone, sample } from '@/js/utils'
import { generate_card } from '@/js/game-utils'
import data_characters from '@/data/characters'
import Sounds from '@/js/sounds'

// === STATE =====================================================================================
const default_state = {
	status: 'ready',
	opponent: null,
	player: null,
	round: {
		opponent_card: null,
		player_card: null
	},
	rounds: [],
	rewards: []
}

const state = clone(default_state)




// === GETTERS =====================================================================================
const getters = {
	fight(state) { return state },
}




// === ACTIONS =====================================================================================
const actions = {

	init_fight({ state, commit, dispatch, rootGetters }, data) {
		commit('EDIT_FIGHT_STATE', { ...clone(default_state), status: 'next-opponent' })

		dispatch('init_character', { type: 'player', level: rootGetters.level })
		dispatch('init_character', { type: 'opponent', level: rootGetters.level })

		let delay = 3000
		if (rootGetters.game.wins.length === 0) delay = 0
		setTimeout(() => { 
			if (state.opponent) commit('EDIT_FIGHT_STATE', { status: 'ready' })
		}, delay)
	},

	init_character({ commit, rootGetters }, data) {
		let cards = []

		let nb_slots = 4

		if (data.type === 'opponent') {
			nb_slots = [ 3 ]
			if (data.level >= 3) nb_slots.push(4)
			if (data.level >= 4) nb_slots.push(5)
			if (data.level >= 5) nb_slots.push(6)
			nb_slots = sample(nb_slots)

			for (var i = 0; i < nb_slots; i++) {
				cards.push(generate_card({ level: data.level }))
			}
		}
		
		let values = {}
		values[data.type] = null
		let c = sample(data_characters.filter((c) => c.playable === (data.type === 'player') && !rootGetters.game.wins.find((w) => w.slug === c.slug)))
		if (c) {
			let life = (data.level + 2) * 2
			if (data.type === 'player') life += 1
			values[data.type] = {
				...c,
				level: data.level,
				type: data.type,
				life,
				life_max: life,
				nb_slots,
				cards
			}
		}
		commit('EDIT_FIGHT_STATE', values)
	},





	select_card({ commit }, data) {
		const index = state.player.cards.findIndex((c) => c.id === data.card.id)
		
		// Remove card
		if (index > -1) {
			let player = { ...state.player, cards: state.player.cards.filter((c) => c.id !== data.card.id) }
			commit('EDIT_FIGHT_STATE', { player })
		}

		// Add card
		else if (state.player.cards.length < state.player.nb_slots) {
			let player = { ...state.player, cards: [ ...state.player.cards, data.card ] }
			commit('EDIT_FIGHT_STATE', { player })
		}
	},


	start_fight({ commit, dispatch }) {
		commit('EDIT_FIGHT_STATE', { rounds: [], status: 'fighting' })
		dispatch('start_round')
	},


	start_round({ state, commit, dispatch, rootGetters }) {
		let last_opponent_card_id = null
		let last_player_card_id = null
		if (state.rounds.length) {
			last_opponent_card_id = state.rounds[state.rounds.length - 1].opponent_card.id
			last_player_card_id = state.rounds[state.rounds.length - 1].player_card.id
		}
		let round = {
			opponent_card: sample(state.opponent.cards.filter((c) => c !== state.round.opponent_card && c.id !== last_opponent_card_id)),
			player_card: sample(state.player.cards.filter((c) => c !== state.round.player_card && c.id !== last_player_card_id))
		}
		commit('EDIT_FIGHT_STATE', { round })
		commit('EDIT_APP_STATE', { shake: { delay: 0.1, color: 'yellow' } })
		setTimeout(() => {
			commit('EDIT_APP_STATE', { shake: null })
			Sounds.play('impact')
		}, 250)

		let speed = 1
		if (rootGetters.app.config.quick_battle) speed = 0.5

		setTimeout(() => {
			dispatch('play_round')
			setTimeout(() => {
				dispatch('end_round')
				setTimeout(() => {
					if (state.player.life > 0 && state.opponent.life > 0) {
						dispatch('start_round')
					} else
						dispatch('end_fight')
				}, 400)
			}, 1250 * speed)
		}, 400)
	},


	play_round({ state, commit }) {

		// Opponent attack
		state.round.opponent_card.attributes.forEach((a) => {
			if (a.type === 'attack') {
				let player_attribute = state.round.player_card.attributes.find((b) => b.type === 'defence' && b.element === a.element && !b.status)
				if (player_attribute) {
					commit('EDIT_ATTRIBUTE', { attribute: a, status: 'hidden' })
					commit('EDIT_ATTRIBUTE', { attribute: player_attribute, status: 'hidden' })
				} else
					commit('EDIT_ATTRIBUTE', { attribute: a, status: 'attacking' })
			}
		})

		// Player attack
		state.round.player_card.attributes.forEach((a) => {
			if (a.type === 'attack') {
				let opponent_attribute = state.round.opponent_card.attributes.find((b) => b.type === 'defence' && b.element === a.element && !b.status)
				if (opponent_attribute) {
					commit('EDIT_ATTRIBUTE', { attribute: a, status: 'hidden' })
					commit('EDIT_ATTRIBUTE', { attribute: opponent_attribute, status: 'hidden' })
				} else
					commit('EDIT_ATTRIBUTE', { attribute: a, status: 'attacking' })
			}
		})

		let opponent_damages = state.round.opponent_card.attributes.filter((a) => a.type === 'attack' && a.status !== 'hidden').length
		let player_damages = state.round.player_card.attributes.filter((a) => a.type === 'attack' && a.status !== 'hidden').length

		if (opponent_damages || player_damages) {
			setTimeout(() => {
				Sounds.play('hit')
				commit('EDIT_FIGHT_STATE', { 
					player: { ...state.player, life: state.player.life - opponent_damages },
					opponent: { ...state.opponent, life: state.opponent.life - player_damages },
				})
				if (opponent_damages || player_damages) {
					commit('EDIT_APP_STATE', { shake: { delay: 0, color: 'red' } })
					setTimeout(() => {
						commit('EDIT_APP_STATE', { shake: null })
					}, 250)
				}
			}, 250)
		}
	},


	end_round({ state, commit }) {
		state.round.opponent_card.attributes.forEach((a) => {
			if (a.status) commit('EDIT_ATTRIBUTE', { attribute: a, status: '' })
		})
		state.round.player_card.attributes.forEach((a) => {
			if (a.status) commit('EDIT_ATTRIBUTE', { attribute: a, status: '' })
		})
		let round = {
			opponent_card: null,
			player_card: null
		}
		commit('EDIT_FIGHT_STATE', { rounds: [ ...state.rounds, state.round ], round })
	},


	end_fight({ state, commit, rootGetters }) {
		commit('EDIT_FIGHT_STATE', { status: 'ready' })

		if (state.player.life > 0) {
			Sounds.play('success')
			commit('EDIT_GAME_STATE', { 
				wins: [ ...rootGetters.game.wins, {
					slug: state.opponent.slug, 
					score: (
						(state.player.life - state.opponent.life /*+ state.rounds.length*/) * (rootGetters.level + 8)
					) 
				} ]
			})
			if (rootGetters.game.wins.length === 17) {
				commit('EDIT_FIGHT_STATE', { status: 'ended' })
				commit('EDIT_GAME_STATE', { status: 'ended' })
			} else {
				Vue.nextTick(() => {
					let rewards = [
						generate_card({ level: rootGetters.level }),
						generate_card({ level: rootGetters.level }),
						generate_card({ level: rootGetters.level }),
						generate_card({ level: rootGetters.level })
					]
					commit('EDIT_FIGHT_STATE', { status: 'ended', rewards, player: { ...state.player, cards: [] } })
				})
			}
		} else {
			Sounds.play('game-lose')
			commit('EDIT_GAME_STATE', { status: 'ended' })
		}
	}

}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_FIGHT_STATE(state, data) {
		for (let i in data) {
			Vue.set(state, i, data[i])
		}
	},

	EDIT_CARD(state, data) {
		for (let i in data) {
			if (i !== 'card') Vue.set(data.card, i, data[i])
		}
	},

	EDIT_ATTRIBUTE(state, data) {
		for (let i in data) {
			if (i !== 'attribute') Vue.set(data.attribute, i, data[i])
		}
	},

}

export default { state, getters, actions, mutations }
